import { createContext } from "reka-ui";
import type { Ref } from "vue";

interface MenuContext {
  readonly id: string | undefined;
  readonly isNested: boolean;
  readonly isMobile: boolean;

  triggerElement: Ref<HTMLElement> | undefined;
}

export const [inject, provide] = createContext<MenuContext>("Menu");
